import UIList from 'UIComponents/list/UIList';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { GRID_BREAKPOINT_MEDIUM } from 'HubStyleTokens/sizes';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UILogo from 'UIComponents/image/UILogo';
import UsageTracker from '../../utils/UsageTracker';
import { HUBSPOT_SOFTWARE_INDEX, useCurrentLearningInterest, useWizardCategoriesMap } from '../../features/wizard';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const CategoryUIList = styled(UIList).withConfig({
  displayName: "WizardCategories__CategoryUIList",
  componentId: "sc-1acem07-0"
})(["width:100%;@media (min-width:", "){max-width:400px;}"], GRID_BREAKPOINT_MEDIUM);
const HubspotUILogo = styled(UILogo).withConfig({
  displayName: "WizardCategories__HubspotUILogo",
  componentId: "sc-1acem07-1"
})(["width:62px;position:relative;top:-2px;margin-right:2px;"]);
const WizardCategories = ({
  onOptionSelect
}) => {
  const {
    selectedCategoryGroup
  } = useCurrentLearningInterest();
  const {
    wizardCategoryMap,
    isLoading
  } = useWizardCategoriesMap();
  const getLevel1Label = index => {
    return index === HUBSPOT_SOFTWARE_INDEX ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "learningCenter.wizard.hubspotsoftware",
      options: {
        imageElement: /*#__PURE__*/_jsx(HubspotUILogo, {
          name: "hubspot-wordmark"
        })
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: `learningCenter.filtersGroups.${index}`
    });
  };
  const trackCategoryClick = category => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-category',
      categoryClicked: category
    });
  };
  const trackSubCategoryClick = subcategory => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-click-sub-category',
      categoryClicked: subcategory
    });
  };
  const renderCategoryList = () => {
    return /*#__PURE__*/_jsx(CategoryUIList, {
      childClassName: "m-bottom-4",
      children: !selectedCategoryGroup ? Object.keys(wizardCategoryMap).map(category => /*#__PURE__*/_jsx(UISelectableButton, {
        block: true,
        onClick: () => trackCategoryClick(category),
        onSelectedChange: () => {
          onOptionSelect(category);
        },
        selected: false,
        title: getLevel1Label(category)
      }, category)) : Object.values(wizardCategoryMap[selectedCategoryGroup]).map(category => /*#__PURE__*/_jsx(UISelectableButton, {
        block: true,
        onClick: () => trackSubCategoryClick(category),
        onSelectedChange: () => {
          onOptionSelect(category);
        },
        selected: false,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.topFilters.cat.${category}`
        })
      }, category))
    });
  };
  return !isLoading ? renderCategoryList() : /*#__PURE__*/_jsx(UILoadingSpinner, {
    size: 'sm'
  });
};
export default WizardCategories;